import React, { useState, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";


const DraggableItem = ({ item, index, moveItem }) => {
    const ItemType = "OPTION";
    const ref = useRef(null);
    const [, drop] = useDrop({
        accept: ItemType,
        hover(draggedItem) {
            if (draggedItem.index === index) return;
            moveItem(draggedItem.index, index);
            draggedItem.index = index;
        }
    });

    const [{ isDragging }, drag] = useDrag({
        type: ItemType,
        item: { ...item, index },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        })
    })
    drag(drop(ref))
    return (
        <div ref={ref}
            style={{
                opacity: isDragging ? 0.5 : 1,
                border: '1px solid black',
                padding: 10,
                marginBottom: 5,
                backgroundColor: 'white',
                cursor: 'move',
            }}>
            {item}
        </div>
    )
}

export default DraggableItem;